import { BlogAPI } from '../../../../apis/BlogAPI'
import BlogSection from '../../../../components/BlogSection'
import BlogWrapper from '../../../../components/BlogWrapper'
import { getBlogWrapperPosts } from '../../../../helpers/blog'

export async function getStaticProps({ params }) {
    const { username } = params

    const { data: authors } = await BlogAPI.safeRequest(
        () => BlogAPI.getAuthorByUsername(username),
        { data: [] },
        `author index getAuthorByUsername ${username}`,
    )
    if (authors.length < 1) return { notFound: true }

    const author = authors[0]

    const { data: posts, headers } = await BlogAPI.safeRequest(
        () => BlogAPI.getPostsByAuthor(author.id),
        { data: [], headers: { 'x-wp-totalpages': '0' } },
        `author index getPostsByAuthor ${username}`,
    )

    const { initialCategories, latestBlogPosts, tags, popularPosts } =
        await getBlogWrapperPosts()

    const totalPages = parseInt(headers['x-wp-totalpages'], 10)

    return {
        props: {
            author,
            initialPosts: posts,
            initialCategories,
            initialTotalPages: totalPages,
            latestBlogPosts,
            tags,
            popularPosts,
        },
        revalidate: 10, // In seconds
    }
}

export async function getStaticPaths() {
    const { data: authors } = await BlogAPI.safeRequest(
        () => BlogAPI.getAllAuthors(),
        { data: [] },
        'author index getStaticPaths',
    )

    const paths = authors.map((author) => ({
        params: { username: author.slug },
    }))

    return {
        paths,
        fallback: 'blocking',
    }
}

const AuthorPosts = ({
    author,
    initialPosts,
    initialTotalPages,
    initialCategories,
    latestBlogPosts,
    tags,
    popularPosts,
}) => {
    const title = `Posts by ${author.name}`
    if (!initialPosts.length) return <p>No posts found for {author.name}</p>

    return (
        <BlogWrapper
            {...{
                title,
                latestBlogPosts,
                initialCategories,
                tags,
                popularPosts,
            }}>
            <BlogSection
                initialPage={1}
                initialPosts={initialPosts}
                initialCategories={initialCategories}
                initialTotalPages={initialTotalPages}
                // categorySlug={categorySlug}
                paginationPrefix={`/author/${author.slug}`}
                pageTitle={`Posts by ${author.name}`}
            />
        </BlogWrapper>
    )
}

export default AuthorPosts
